import * as React from 'react';
import * as style from './style.css';

export const MainSection = ({ children }: React.PropsWithChildren): React.JSX.Element => {
  return <div className={style['container']}>{children}</div>;
};
